import React from 'react'
import { INodeProps } from '../lib/legoParser'
import TreeNode, { clickProp } from './treeNode'
import { ComponentsContext } from '../lib/context'
interface IWapperProps {
  components: any
}
const TreeNodeWapper = (props: IWapperProps & INodeProps & clickProp) => {
  const { components, ...otherProps } = props
  return (
    <ComponentsContext.Provider value={components}>
      <TreeNode {...otherProps}></TreeNode>
    </ComponentsContext.Provider>
  )
}

export default TreeNodeWapper
